/**
 * Gates access to the budget pacing consumption report.
 * - Feature off (`allowBudgetPacing` falsy) → no link
 * - Feature on + `budgetPacingActive === false` → no link (campaign not yet in BP motor)
 * - Feature on + field absent or `true` → link (legacy-compatible)
 */
export const canShowSpendReportLink = (
  allowBudgetPacing: boolean | undefined,
  budgetPacingActive: boolean | undefined
): boolean => !!allowBudgetPacing && budgetPacingActive !== false
